import React from "react";
import { Select } from "antd";

import { useBenchmarkContext } from "./hook";
import styles from "./styles.less";
import { TitleCase } from "@/utils/string";
import { oc } from "ts-optchain";

export default () => {
  const { isAll, group, setGroup, groups } = useBenchmarkContext();

  return (
    <Select
      mode={isAll ? undefined : "multiple"}
      showSearch
      className={styles.groupSelect}
      optionFilterProp="children"
      placeholder="Find industry"
      onChange={findGroup}
      value={group}
      filterOption={(input, option) =>
        oc(option)
          .children("")
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      }
    >
      {groups.map(e => (
        <Select.Option key={e} value={e}>
          {TitleCase(e)}
        </Select.Option>
      ))}
    </Select>
  );

  function findGroup(e: string[]) {
    if (isAll) {
      const selected:string = e as any
      setGroup([selected])
      const target = document.getElementsByClassName(e as any)[0];
      target &&
        target.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "nearest"
        });
    } else {
      setGroup(e)
    }
  }
};
